//#region src/ai.ts
function getAllModelsFromConfig(config) {
	return Object.values(config).flat();
}
function isValidModelInConfig(model, config) {
	return getAllModelsFromConfig(config).includes(model);
}

//#endregion
//#region src/config.ts
const isNode$1 = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
const PORT = {
	API: 3001,
	WEB: 3e3,
	WEB_ADMIN: 3002,
	QUEUE: 5001
};
const MENTISS_REDIS_DB = {
	API: 1,
	QUEUE: 2
};
const MENTISS_REDIS_HOST = isNode$1 && process.env.MENTISS_REDIS_HOST ? process.env.MENTISS_REDIS_HOST : "127.0.0.1";
const MENTISS_REDIS_PORT = isNode$1 && process.env.MENTISS_REDIS_PORT ? Number.parseInt(process.env.MENTISS_REDIS_PORT, 10) : 6379;

//#endregion
//#region src/constant.ts
const DataSettingOptions = {
	D6_1SR1WT_2WW_2VG: "D6_1SR1WT_2WW_2VG",
	D9_1HT1SR1WT_3WW_3VG: "D9_1HT1SR1WT_3WW_3VG",
	D10_ULTIMATE_TRIAL: "D10_ULTIMATE_TRIAL"
};
const GameSettingOptions = {
	G6_1SR1WT_2WW_2VG: "G6_1SR1WT_2WW_2VG",
	G9_1HT1SR1WT_3WW_3VG: "G9_1HT1SR1WT_3WW_3VG",
	G10_ULTIMATE_TRIAL: "G10_ULTIMATE_TRIAL",
	USER_CUSTOM_CONFIG: "USER_CUSTOM_CONFIG",
	HUMAN_VS_AI: "HUMAN_VS_AI",
	AGENT_MODE: "AGENT_MODE",
	MODEL_COMPARISON: "MODEL_COMPARISON",
	BYOM: "BYOM"
};
const PlayerRole = {
	seer: "seer",
	witch: "witch",
	villager: "villager",
	werewolf: "werewolf",
	hunter: "hunter",
	gravekeeper: "gravekeeper",
	gargoyle: "gargoyle",
	snow_wolf: "snow_wolf",
	alpha_wolf: "alpha_wolf",
	knight: "knight",
	demon_hunter: "demon_hunter",
	guard: "guard",
	black_market_dealer: "black_market_dealer",
	wraith_knight: "wraith_knight",
	blood_moon_herald: "blood_moon_herald"
};
const RoleCode = {
	seer: "SR",
	witch: "WT",
	villager: "VG",
	werewolf: "WW",
	hunter: "HT",
	gravekeeper: "GK",
	gargoyle: "GY",
	snow_wolf: "SW",
	alpha_wolf: "AW",
	knight: "KN",
	demon_hunter: "DH",
	guard: "GD",
	black_market_dealer: "BD",
	wraith_knight: "WK",
	blood_moon_herald: "BH"
};
const RoleFaction = {
	seer: "good",
	witch: "good",
	villager: "good",
	hunter: "good",
	werewolf: "evil",
	snow_wolf: "evil",
	alpha_wolf: "evil",
	knight: "good",
	guard: "good",
	demon_hunter: "good",
	black_market_dealer: "good",
	gravekeeper: "good",
	wraith_knight: "evil",
	blood_moon_herald: "evil",
	gargoyle: "evil"
};
const PlayerNames = [
	"Alice",
	"Bob",
	"Charlie",
	"David",
	"Eve",
	"Frank",
	"Grace",
	"Henry",
	"Iris",
	"Jason",
	"Kate",
	"Liam",
	"Matthew",
	"Nathan",
	"Ocean",
	"Paul",
	"Quinn",
	"Rachel",
	"Sam",
	"Tim",
	"Uma",
	"Victor",
	"Wendy",
	"Xavier",
	"Yara",
	"Zach"
];
const LANGUAGE_ENUM_VALUES = [
	"zh",
	"en",
	"fr",
	"ar",
	"es",
	"ja",
	"tw",
	"ko"
];
const PLAYER_ROLE_ENUM_VALUES = [
	"seer",
	"witch",
	"villager",
	"werewolf",
	"hunter",
	"gravekeeper",
	"gargoyle",
	"snow_wolf",
	"alpha_wolf",
	"knight",
	"demon_hunter",
	"guard",
	"black_market_dealer",
	"lucky_one",
	"wraith_knight",
	"blood_moon_herald"
];
let NightPhaseKey = /* @__PURE__ */ function(NightPhaseKey$1) {
	NightPhaseKey$1["black_market_dealer"] = "black_market_dealer";
	NightPhaseKey$1["gargoyle"] = "gargoyle";
	NightPhaseKey$1["evil_faction"] = "evil_faction";
	NightPhaseKey$1["guard"] = "guard";
	NightPhaseKey$1["witch"] = "witch";
	NightPhaseKey$1["seer"] = "seer";
	NightPhaseKey$1["hunter"] = "hunter";
	NightPhaseKey$1["knight"] = "knight";
	NightPhaseKey$1["gravekeeper"] = "gravekeeper";
	NightPhaseKey$1["demon_hunter"] = "demon_hunter";
	NightPhaseKey$1["lucky_one"] = "lucky_one";
	return NightPhaseKey$1;
}({});
const ROLE_EMOJIS = {
	seer: "🔮",
	witch: "🧙‍♀️",
	hunter: "🏹",
	villager: "👥",
	werewolf: "🐺",
	gargoyle: "🗿",
	snow_wolf: "❄️",
	alpha_wolf: "👑",
	wraith_knight: "💀",
	blood_moon_herald: "🩸",
	knight: "⚔️",
	guard: "🛡️",
	demon_hunter: "👺",
	gravekeeper: "⚰️",
	black_market_dealer: "💰",
	lucky_one: "🍀"
};
const SUBPHASE_EMOJIS = {
	round_night_start: "🌙",
	round_black_market_dealer: "💰",
	round_gargoyle: "🗿",
	round_werewolf_discuss: "🐺",
	round_werewolf_discuss_2: "🐺",
	round_werewolf_kill: "🔪",
	round_guard: "🛡️",
	round_witch_action: "🧙‍♀️",
	round_seer_verify: "🔮",
	round_hunter_action: "🏹",
	round_knight: "⚔️",
	round_gravekeeper: "⚰️",
	round_demon_hunter: "👺",
	round_lucky_one: "🍀",
	round_night_complete: "🌅",
	round_day_start: "☀️",
	round_round_speech: "💬",
	round_vote: "🗳️",
	round_tied_round_speech: "⚖️",
	round_tied_vote: "🔄",
	round_day_complete: "🌆"
};
const EVIL_ROLE_POOL = [
	PlayerRole.alpha_wolf,
	PlayerRole.snow_wolf,
	PlayerRole.wraith_knight,
	PlayerRole.gargoyle,
	PlayerRole.blood_moon_herald,
	PlayerRole.werewolf
];
const GOOD_ROLE_POOL = [
	PlayerRole.seer,
	PlayerRole.witch,
	PlayerRole.hunter,
	PlayerRole.knight,
	PlayerRole.gravekeeper,
	PlayerRole.black_market_dealer,
	PlayerRole.demon_hunter,
	PlayerRole.guard,
	PlayerRole.villager
];
const BENCHMARK_DISPLAYED_MODELES = {
	D6_1SR1WT_2WW_2VG: [
		"openai/gpt-5",
		"google/gemini-3-pro-preview",
		"google/gemini-2.5-pro",
		"anthropic/claude-sonnet-4.5",
		"x-ai/grok-4",
		"deepseek/deepseek-v3.2-exp"
	],
	D9_1HT1SR1WT_3WW_3VG: [
		"openai/gpt-5",
		"google/gemini-2.5-pro",
		"anthropic/claude-sonnet-4.5",
		"x-ai/grok-4",
		"deepseek/deepseek-v3.2-exp"
	],
	D10_ULTIMATE_TRIAL: [
		"openai/gpt-5.2-pro",
		"google/gemini-3-pro-preview",
		"google/gemini-3-flash-preview",
		"anthropic/claude-opus-4.5",
		"x-ai/grok-4",
		"z-ai/glm-4.7",
		"z-ai/glm-5",
		"moonshotai/kimi-k2.5"
	]
};
const BENCHMARK_RANKING_MODELES = {
	D6_1SR1WT_2WW_2VG: [
		"openai/gpt-5",
		"google/gemini-3-pro-preview",
		"google/gemini-2.5-pro",
		"anthropic/claude-sonnet-4.5",
		"x-ai/grok-4",
		"deepseek/deepseek-v3.2-exp"
	],
	D9_1HT1SR1WT_3WW_3VG: [
		"openai/gpt-5",
		"google/gemini-2.5-pro",
		"anthropic/claude-sonnet-4.5",
		"x-ai/grok-4",
		"deepseek/deepseek-v3.2-exp"
	],
	D10_ULTIMATE_TRIAL: [
		"openai/gpt-5.2-pro",
		"google/gemini-3-pro-preview",
		"anthropic/claude-opus-4.5",
		"x-ai/grok-4",
		"z-ai/glm-4.7"
	]
};
const INTERNALCOMPARISON_DISPLAYED_MODELES = {
	"openai": ["openai/gpt-5.2-pro", "openai/gpt-5-pro"],
	"google": ["google/gemini-3-pro-preview", "google/gemini-2.5-pro"],
	"anthropic": ["anthropic/claude-opus-4.5", "anthropic/claude-opus-4.1"],
	"x-ai": ["x-ai/grok-4", "x-ai/grok-3"],
	"z-ai": ["z-ai/glm-4.7", "z-ai/glm-4.6"],
	"moonshotai": ["moonshotai/kimi-k2.5", "moonshotai/kimi-k2-thinking"]
};
const COMPANY_DISPLAY_NAMES = {
	"openai": "OpenAI",
	"google": "Google",
	"anthropic": "Anthropic",
	"x-ai": "xAI",
	"deepseek": "DeepSeek",
	"meta": "Meta",
	"z-ai": "Z.ai",
	"moonshotai": "MoonshotAI"
};
const AI_PARAMS = {
	temperature: .6,
	presencePenalty: .7,
	frequencyPenalty: .5,
	max_reasoning_tokens: 5120
};

//#endregion
//#region src/env.ts
const isNode = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
const IS_PRODUCTION = isNode ? process.env.MENTISS_ENV === "prod" : false;

//#endregion
//#region src/util.ts
/**
* 随机角色配置生成器
* 用于10人局随机配置：3狼人阵营 + 4好人（随机）+ 3平民（固定）
*/
/**
* Fisher-Yates shuffle algorithm
* 随机打乱数组
*/
function shuffleArray(array) {
	const shuffled = [...array];
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	return shuffled;
}
/**
* 生成随机10人局游戏设置字符串
*
* 规则：
* - 狼人阵营：从6个角色中随机选3个
* - 好人阵营：从9个角色中随机选4个，另外加3个固定平民
* - 最终配比：3狼人阵营 + (3-4)神 + (3-4)平民 = 10人
* - 生成格式：D10_[rolecode]-R (R表示随机生成)
*
* @returns 随机生成的游戏设置字符串，如 "D10_1SR1WT_3WW_3VG-R"
*/
function generateSettingFor10UltimateTrial(gameType) {
	const selectedEvilRoles = shuffleArray(EVIL_ROLE_POOL).slice(0, 3);
	const selectedGoodRoles = shuffleArray(GOOD_ROLE_POOL).slice(0, 4);
	const fixedVillagers = [
		PlayerRole.villager,
		PlayerRole.villager,
		PlayerRole.villager
	];
	const allRoles = [
		...selectedEvilRoles,
		...selectedGoodRoles,
		...fixedVillagers
	];
	const roleCounts = {};
	let villagerCount = 0;
	for (const role of allRoles) if (role === PlayerRole.villager) villagerCount++;
	else roleCounts[role] = (roleCounts[role] || 0) + 1;
	return `${generateRoleCodeStringFromCheckbox(gameType, roleCounts, villagerCount)}-R`;
}
/**
* 从角色代码字符串生成游戏设置代码
* 输入格式: "1SR1GK1WK2VG1AW" (任意顺序，无空格)
* 输出格式: "G6_1GK1SR_1AW1WK_2VG" 或 "D6_1GK1SR_1AW1WK_2VG"
* @param gameType 游戏类型，用于确定前缀。
*   - GameType.game: 使用 "G" 前缀，表示游戏模式
*   - GameType.data: 使用 "D" 前缀，表示数据模式
*
* @param gameRecord 游戏记录，包含游戏类型信息
* @param roleCodeString 角色代码字符串，如 "1SR1GK1WK2VG1AW"
* @returns 游戏设置代码字符串
*/
function generateGameSettingFromRoleCodeString(gameType, roleCodeString) {
	const codeToRole = {};
	for (const [role, code] of Object.entries(RoleCode)) codeToRole[code] = role;
	const roleCounts = /* @__PURE__ */ new Map();
	const regex = /(\d+)([A-Z]{2})/g;
	let match;
	let totalPlayers = 0;
	while ((match = regex.exec(roleCodeString)) !== null) {
		const [, countStr, code] = match;
		const count = Number.parseInt(countStr, 10);
		const role = codeToRole[code];
		if (!role) throw new Error(`未知的角色代码: ${code}`);
		roleCounts.set(role, (roleCounts.get(role) || 0) + count);
		totalPlayers += count;
	}
	const goodRoles = [];
	const evilRoles = [];
	let villagerCount = 0;
	for (const [role, count] of roleCounts) {
		const faction = RoleFaction[role] || "evil";
		if (role === PlayerRole.villager) villagerCount = count;
		else if (faction === "good") for (let i = 0; i < count; i++) goodRoles.push(role);
		else if (faction === "evil") for (let i = 0; i < count; i++) evilRoles.push(role);
	}
	if (goodRoles.length === 0) throw new Error("必须有好人阵营特殊角色2");
	if (evilRoles.length === 0) throw new Error("必须有狼人阵营角色");
	if (villagerCount === 0) throw new Error("必须有村民角色");
	if (evilRoles.filter((role) => role === PlayerRole.werewolf).length + evilRoles.filter((role) => role === PlayerRole.snow_wolf).length + evilRoles.filter((role) => role === PlayerRole.alpha_wolf).length >= villagerCount + goodRoles.length) throw new Error("狼人数量不能大于或等于村民和好人特殊角色的总和");
	const goodRoleCounts = countAndSortRoles(goodRoles);
	const evilRoleCounts = countAndSortRoles(evilRoles);
	const goodSpecialPart = goodRoleCounts.map(([code, count]) => `${count}${code}`).join("");
	const evilPart = evilRoleCounts.map(([code, count]) => `${count}${code}`).join("");
	return `${gameType === "data" ? "D" : "G"}${totalPlayers}_${goodSpecialPart}_${evilPart}_${villagerCount}${RoleCode[PlayerRole.villager]}`;
}
function countAndSortRoles(roles) {
	const roleCountMap = /* @__PURE__ */ new Map();
	for (const role of roles) {
		const code = RoleCode[role];
		roleCountMap.set(code, (roleCountMap.get(code) || 0) + 1);
	}
	return Array.from(roleCountMap.entries()).sort(([codeA], [codeB]) => codeA.localeCompare(codeB));
}
/**
* Generate a role code string from checkbox selections and then create GameSetting
* Used for "standard 6 player", "standard 9 player", and "custom 10 player"
* @param gameType Type of game setting ('game' or 'data')
* @param selectedRoles Map of role keys to counts from checkbox selections
* @param villagerCount Number of villagers from checkbox selections
* @returns Generated GameSetting string
*/
function generateRoleCodeStringFromCheckbox(gameType, selectedRoles, villagerCount) {
	const goodRoles = [];
	const evilRoles = [];
	let actualVillagerCount = villagerCount;
	for (const [roleKey, count] of Object.entries(selectedRoles)) if (count > 0) {
		const role = roleKey;
		if (role === PlayerRole.villager) actualVillagerCount += count;
		else {
			const faction = RoleFaction[role] || "evil";
			if (faction === "good") for (let i = 0; i < count; i++) goodRoles.push(role);
			else if (faction === "evil") for (let i = 0; i < count; i++) evilRoles.push(role);
		}
	}
	const totalPlayers = goodRoles.length + evilRoles.length + actualVillagerCount;
	const goodRoleCounts = countAndSortRoles(goodRoles);
	const evilRoleCounts = countAndSortRoles(evilRoles);
	const goodSpecialPart = goodRoleCounts.map(([code, count]) => `${count}${code}`).join("");
	const evilPart = evilRoleCounts.map(([code, count]) => `${count}${code}`).join("");
	return `${gameType === "data" ? "D" : "G"}${totalPlayers}_${goodSpecialPart}_${evilPart}_${actualVillagerCount}${RoleCode[PlayerRole.villager]}`;
}
/**
* Get display name for a company
*/
function getCompanyDisplayName(company) {
	return COMPANY_DISPLAY_NAMES[company] || company;
}
/**
* Get model display name (without company prefix)
*/
function getModelDisplayName(fullModelName) {
	const parts = fullModelName.split("/");
	return parts.length > 1 ? parts[1] : fullModelName;
}
function getBenchmarkModels(gameSetting) {
	const models = BENCHMARK_DISPLAYED_MODELES[gameSetting];
	if (!models) throw new Error(`Unknown game setting for benchmark models: ${gameSetting}`);
	return models;
}
function getBenchmarkRankingModels(gameSetting) {
	const models = BENCHMARK_RANKING_MODELES[gameSetting];
	if (!models) throw new Error(`Unknown game setting for benchmark ranking: ${gameSetting}`);
	return models;
}
function getCompanyModels(company) {
	const models = INTERNALCOMPARISON_DISPLAYED_MODELES[company];
	if (!models) throw new Error(`Unknown company for internal comparison: ${company}`);
	return models;
}
function getAllCompanies() {
	return Object.keys(INTERNALCOMPARISON_DISPLAYED_MODELES);
}

//#endregion
export { AI_PARAMS, BENCHMARK_DISPLAYED_MODELES, BENCHMARK_RANKING_MODELES, COMPANY_DISPLAY_NAMES, DataSettingOptions, EVIL_ROLE_POOL, GOOD_ROLE_POOL, GameSettingOptions, INTERNALCOMPARISON_DISPLAYED_MODELES, IS_PRODUCTION, LANGUAGE_ENUM_VALUES, MENTISS_REDIS_DB, MENTISS_REDIS_HOST, MENTISS_REDIS_PORT, NightPhaseKey, PLAYER_ROLE_ENUM_VALUES, PORT, PlayerNames, PlayerRole, ROLE_EMOJIS, RoleCode, RoleFaction, SUBPHASE_EMOJIS, countAndSortRoles, generateGameSettingFromRoleCodeString, generateRoleCodeStringFromCheckbox, generateSettingFor10UltimateTrial, getAllCompanies, getAllModelsFromConfig, getBenchmarkModels, getBenchmarkRankingModels, getCompanyDisplayName, getCompanyModels, getModelDisplayName, isValidModelInConfig, shuffleArray };
//# sourceMappingURL=index.mjs.map